import * as React from 'react';
import {Button, ButtonToolbar, Modal} from 'reactstrap';
import {change, Field, InjectedFormProps, reduxForm} from 'redux-form';
import renderSelectField from '../../../../theme/components/form/Select';
import renderInputField from '../../../../theme/components/form/Input';
import validate from './validate';
import {mirana} from '@wize/mirana-proto/mirana-proto';

interface VisicoolerModeloModalProps {
    toggle: any;
    isOpen: boolean;
    modeloId?: number;
    modelo?: mirana.IVisicoolerModelo;
    inNewMode: boolean;
}

interface VisicoolerModeloModalState {
    action: string;
}

class VisicoolerModeloModal extends React.PureComponent<InjectedFormProps & ReduxProps & VisicoolerModeloModalProps, VisicoolerModeloModalState> {

    constructor(props) {
        super(props);
        this.state = {
            action: 'Nuevo'
        };
    }

    private handleReset = () => {
        this.props.toggle();
    };

    public componentWillReceiveProps(props) {
        if(!this.props.isOpen){
            this.props.dispatch(change('visicooler_modelo_form', 'modeloId', props.modelo ? props.modelo.modeloId : ''));
            this.props.dispatch(change('visicooler_modelo_form', 'descripcion', props.modelo ? props.modelo.descripcion : ''));
            this.props.dispatch(change('visicooler_modelo_form', 'cuota', props.modelo ? props.modelo.cuota : ''));
            this.props.dispatch(change('visicooler_modelo_form', 'estado', props.modelo ? props.modelo.estado : null));
        }
        if (!this.props.inNewMode) {
            this.setState({action: 'Editar'});
        } else {
            this.setState({action: 'Nuevo'});
            this.props.dispatch(change('visicooler_modelo_form', 'estado', 1));
        }
    }

    public render() {
        const {handleSubmit} = this.props;
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}
                   className={`modal-dialog--primary`}>
                <div className='modal__header'>
                    <span className='lnr lnr-cross modal__close-btn' onClick={this.props.toggle}/>
                    <h4 className='bold-text  modal__title'>{this.state.action} modelo</h4>
                </div>
                <div className='modal__body modelo-modal'>
                    <form className='material-form' onSubmit={handleSubmit}>
                        <Field
                            name='descripcion'
                            component={renderInputField}
                            type='text'
                            label='Descripcion'
                        />
                        <Field
                            name='cuota'
                            component={renderInputField}
                            type='text'
                            label='Cuota'
                        />
                        <div className='form__form-group'>
                            <label className='form__form-group-label'>Estado </label>
                            <div className='form__form-group-field'>
                                <Field
                                    name='estado'
                                    component={renderSelectField}
                                    placeholder='Seleccione'
                                    options={[{value: 1, label: 'ACTIVO'}, {value: 2, label: 'INACTIVO'}]}
                                />
                            </div>
                        </div>
                        <ButtonToolbar className='modal__footer'>
                            <Button onClick={this.handleReset}>Cancelar</Button>{' '}
                            <Button type='submit' color='primary'>Aceptar</Button>
                        </ButtonToolbar>
                    </form>
                </div>
            </Modal>)
    }
}

export default reduxForm({
    form: 'visicooler_modelo_form', // a unique identifier for this form
    destroyOnUnmount: false,
    validate,
})(VisicoolerModeloModal);


// WEBPACK FOOTER //
// ./src/components/pages/visicooler/modelos/visicooler-modelo-modal.tsx